import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { useContent } from '../hooks/useContent';
import FeatureAdvancedAlgos from './FeatureAdvancedAlgos';
import FeatureNextGen from './FeatureNextGen';
import FeaturePrecisionAlerts from './FeaturePrecisionAlerts';

const buildFallback = (t) => ({
  advanced_badge_en: t.features.advancedAlgos.badge, advanced_badge_el: t.features.advancedAlgos.badge,
  advanced_title_en: t.features.advancedAlgos.title, advanced_title_el: t.features.advancedAlgos.title,
  advanced_description_en: t.features.advancedAlgos.description, advanced_description_el: t.features.advancedAlgos.description,
  advanced_cta_en: t.features.advancedAlgos.cta, advanced_cta_el: t.features.advancedAlgos.cta,
  nextgen_badge_en: t.features.nextGen.badge, nextgen_badge_el: t.features.nextGen.badge,
  nextgen_title1_en: t.features.nextGen.title1, nextgen_title1_el: t.features.nextGen.title1,
  nextgen_title2_en: t.features.nextGen.title2, nextgen_title2_el: t.features.nextGen.title2,
  nextgen_description_en: t.features.nextGen.description, nextgen_description_el: t.features.nextGen.description,
  nextgen_cta_en: t.features.nextGen.cta, nextgen_cta_el: t.features.nextGen.cta,
  alerts_badge_en: t.features.precisionAlerts.badge, alerts_badge_el: t.features.precisionAlerts.badge,
  alerts_title1_en: t.features.precisionAlerts.title1, alerts_title1_el: t.features.precisionAlerts.title1,
  alerts_title2_en: t.features.precisionAlerts.title2, alerts_title2_el: t.features.precisionAlerts.title2,
  alerts_description_en: t.features.precisionAlerts.description, alerts_description_el: t.features.precisionAlerts.description,
  alerts_cta_en: t.features.precisionAlerts.cta, alerts_cta_el: t.features.precisionAlerts.cta,
});

const FeaturesSection = () => {
  const { t } = useLanguage();
  const { pick } = useContent('features', buildFallback(t));

  return (
    <div className="bg-gradient-to-b from-[#050811] via-[#0a0e27] to-[#050811] py-20">
      <FeatureAdvancedAlgos t={t} pick={pick} />
      <FeatureNextGen t={t} pick={pick} />
      <FeaturePrecisionAlerts t={t} pick={pick} />
    </div>
  );
};

export default FeaturesSection;
